<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Cash Buyer</h3>
        <b-form role="form" @submit.prevent="editProduct">
            <b-row>
              <b-col cols="12">
                    <b-form-group label="Product">
                        <el-select v-model="form.product" placeholder="Select">
                            <el-option label="Property Cash Purchase" value="Property Cash Purchase"></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Property Details">
                        <b-form-input v-model="form.prod_pm_project_name" type="text" :disabled="true"></b-form-input>
                    </b-form-group>
                </b-col>
              <b-col cols="12">
                    <b-form-group label="Product Value(RM)" class="mb-2">
                        <b-form-input
                        v-model="form.loan_amount"
                        type="text"
                        step="0.01"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Status">
                        <el-select v-model="form.bank_status" filterable placeholder="Select" :disabled="
                            !checkAccess(['p_product__manage']) && !auth_user.subscription.scrb_is_my_own
                        ">
                            <el-option
                            v-for="bank_status in bank_status_options"
                            :key="bank_status.value"
                            :label="bank_status.label"
                            :value="bank_status.value"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6" > 
                    <b-form-group label="SPA Signing Date">
                        <el-date-picker v-model="form.prod_bnk_appointment_at" type="datetime"  format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="Select appointment time and date">
                        </el-date-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="6" class="mx-auto text-center mt-3 pt-2"> 
                    <b-form-group>
                        <b-button block variant="outline-primary"
                                    @click="exportToGoogleCalendar(form.prod_bnk_appointment_at)" 
                                    class="el-icon-date"
                                    style="cursor: pointer;">
                            Export to Calendar
                        </b-button>
                    </b-form-group>
                </b-col>
               
                <b-col md="8" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option , DatePicker } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { usePMPStore } from '@/stores/pmpStore'
import { useProductStore } from '@/stores/productStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import { useAuthStore } from '@/stores/authStore'
import {BANK_CANNOT_EDIT_STATUS, BANK_APPROVAL_STATUS, BANK_STATUS} from '@/assets/js/status.js'
import {isEqual} from 'lodash'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import moment from 'moment'

export default {
    props:{
      show_edit_cash_buyer: Boolean,
        bank: Object,
        product: Object,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,

    },
    data() {
        return {
            prodSSADetails: null, 
            is_override_loan_amount:true,
            form:{
              product: 'Property Cash Purchase',
                property_details: '',
                product_value: '',
                bank_status: '',
                spa_signing_date: '',
                prod_bnk_appointment_at: null,

            },
            is_loading_btn: false,
            is_loading_bank: false,
            bank_status_options: BANK_STATUS,
            update_status_role_ids: [1],
            is_override_installment: false
        }
    },
    computed: {
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useAccessControlStore, ['userBankerList', 'userLoanOfficerList']),
        show: {
            get() {
                return this.show_edit_cash_buyer
            },
            set(newVal) {
                this.$emit('update:show_edit_cash_buyer', newVal)
            },
        },
        cannotEdit(){
            return BANK_CANNOT_EDIT_STATUS.includes(this.bank.prod_bnk_stage_status) && !(this.checkAccess(['p_product__manage']))
        },
				isApprovedBank(){
					return BANK_APPROVAL_STATUS.indexOf(this.form.bank_status) !== -1;
				}
    },
    watch:{
        product:{
            async handler(newVal, oldVal){
				if(!isEqual(newVal, oldVal)){
                    await this.setProductDetail(newVal)
                }
                this.prodSSADetails = newVal.prod_ssa_detail;
            },
            immediate: true,
        },
        bank:{
            async handler(newVal, oldVal){
                await this.setForm(newVal)
                await this.getBanks()
            },
            immediate: true,
        },
        'form.spa_price':{
            handler(newVal){
                if(!this.is_override_loan_amount){
                    this.form.loan_amount = calculateLoanAmount(newVal, this.form.margin_finance)
                }
            },
            immediate: false,
        },
        'form.bank_status': {
            handler(newStatus, oldStatus) {

                if (newStatus === 'Approved' && newStatus !== oldStatus) {
                    const selectedSSA = this.prodSSADetails;
                    if (selectedSSA) {
                        this.sendApprovalEmailToSSA(selectedSSA.name, selectedSSA.email);
                    }
                }
            },
            immediate: false 
        },

    },
    methods:{
        ...mapActions(usePMPStore, ['getPMPProjectBanks', 'syncV2CaseToPMP']),
        ...mapActions(useProductStore, ['addPropertyProductBank', 'updatePropertyProductBank', 'getBankersBasedOnBank', 'checkGenerateCommission']),
     
        async setForm(data){
            this.form.bank_code = data.prod_bnk_code
            this.form.bank_name = data.prod_bnk_name
            this.form.spa_price = data.prod_bnk_spa_amount
            this.form.bank_status = data.prod_bnk_stage_status
            this.form.loan_amount = data.prod_bnk_loan_amount
            this.form.prod_bnk_appointment_at = data.prod_bnk_appointment_at
        },
        async setProductDetail(data){
            this.form.prod_pm_project_name = data.product_detail.prod_pm_project_name

        },
        async getBanks(){
            this.is_loading_bank = true
            axios.get(services.customer + 'customer/' + this.product.prod_customer_id +'/dsr.eligibilities', {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                    this.is_loading_bank = false
                })
                .catch(e =>{
                    this.is_loading_bank = false
                    this.errorFunction(e)
                })
        },
        async editProductDetail(){
            try{
                let data = {
                    "prod_agent_id": this.product.prod_agent_id,
                    "prod_agent_username" : this.product.prod_agent_username,
                    "prod_customer_basket" : this.product.prod_customer_basket,
                    "prod_customer_id" : this.product.prod_customer_id,
                    "prod_customer_name" : this.product.prod_customer_name,
                    "prod_type": this.product.prod_type,
                    "prod_loan_officer_id": this.form.prod_loan_officer_id,
                    "prod_main_status": this.product.prod_main_status,
                    "prod_status": this.product.prod_status,
                    "prod_loan_officer_id": this.form.prod_loan_officer_id,
                    "product_detail" : {
                        "prod_pm_project_name": this.product.product_detail.prod_pm_project_name,
                    }
                }
                const res = await axios.post(services.product + 'product/' + this.product.prod_id, data, {headers: getHeader()})
            }catch(e){
                this.errorFunction(e)
            }
        },
        async editBank(){
            let bankData = {
                "prod_bnk_name": this.form.bank_name,
                "prod_bnk_prod_id": this.bank.prod_bnk_prod_id,
                "prod_bnk_logo_url": this.dsr_bank ? this.dsr_bank.bank_image_url : this.bank.prod_bnk_logo_url,
                "prod_bnk_banker_id": this.form.banker_id ?? null,
                "prod_bnk_stage_status": this.form.bank_status,
                "prod_bnk_loan_amount": this.form.loan_amount,
                "prod_bnk_spa_amount": this.form.spa_price,
                "prod_bnk_interest": this.form.interest,
                "prod_bnk_margin": this.form.margin_finance,
                "prod_bnk_tenure": this.form.tenure_years,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": this.form.installment,
                "prod_bnk_code": this.form.bank_code,
                "prod_bnk_submission_date": this.form.prod_bnk_submission_date,
                "prod_bnk_approved_date": this.form.approved_date,
                "prod_bnk_lo_sign_date": this.bank.prod_bnk_lo_sign_date,
                "prod_bnk_add_cost": this.form.prod_bnk_add_cost,
                "prod_bnk_appointment_at": this.form.prod_bnk_appointment_at,
            }

            const res = await axios.post(services.product + 'product-bank/' + this.bank.prod_bnk_id, bankData, {headers: getHeader()})
            if(this.product.product_detail.prod_pm_property_src != 'HESTIA') {
                const pmpRes = await this.syncV2CaseToPMP(this.product.prod_id)
            }
        },
        async editProduct(){
            try{
                this.is_loading_btn = true
                await this.editBank()
                await this.editProductDetail()
                this.resetField()
								this.is_loading_btn = false
                this.$emit('update:show_edit_cash_buyer', false)
                caseEventBus.$emit('refresh-cases')
                this.notifySuccess('<b>Bank</b> - Successfully Updated.')
            }catch(e){
                this.is_loading_btn = false
                this.errorFunction(e)
            }
        },
        resetField(){
            this.dsr_bank = null
        },
        exportToGoogleCalendar(appointmentAt) {
            const caseName = this.product.prod_customer_name

            // Check if appointmentAt is not empty
            if (!this.isEmpty(appointmentAt)) {
                // Format the appointment date for the Google Calendar link
                const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
                // Create the Google Calendar link
                const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, caseName);
                // Open the link in a new tab
                window.open(googleCalendarLink, '_blank');
            }
        },

        formatGoogleCalendarDate(appointmentAt) {
            const date = new Date(appointmentAt);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}T${hours}${minutes}${seconds}`;
        },

        generateGoogleCalendarLink(formattedDate, caseName) {
            // Generate Google Calendar link with necessary details
            const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${caseName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

            return googleCalendarLink;
        },
    }
}
</script>